import React, { useState, useEffect, Suspense } from 'react';
import './App.css';
import '../node_modules/draft-js/dist/Draft.css';
import { Switch, Route, useLocation } from 'react-router-dom';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "../node_modules/@syncfusion/ej2-base/styles/material.css";
// import "../node_modules/@syncfusion/ej2-grids/styles/material.css";
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Products from './components/Products';
import Dashboard from './components/Retailer/Dashboard';
import AllProducts from './components/Retailer/AllProducts';
import HealthCamps from './components/Retailer/HealthCamps';
import PharmaEvents from './components/Retailer/PharmaEvents';
import Index from './components/Retailer/Index';
import Pricing from './components/Pricing';
import RegisterRetailer from './components/Retailer/RegisterRetailer';
import ChoosePricing from './components/Retailer/ChoosePricing';
import MultiStepRegister from './Account/MultiStepRegister';
import CreateProduct from './components/Retailer/CreateProduct';
import ImportProduct from './components/Retailer/ImportProduct';
import CreateHealthCamps from './components/Retailer/CreateHealthCamps';
import CreatePharmaEvents from './components/Retailer/CreatePharmaEvents';
import Contact from './components/Contact';
import About from './components/About';
import Events from './components/Events';
import AllRecords from './components/AllRecords';
import RetailerDetails from './components/RetailerDetails';
import MedicalEventsDetails from './components/MedicalEventsDetails';
import SportEventDetails from './components/SportEventDetails';
import SportBookingDetails from './components/SportBookingDetails';
import StoreProfileWrap from './components/Retailer/StoreProfileWrap';
import NotAuthorized from './components/NotAuthorized';
import AuthenticateUser from './Router/AuthenticateUser';
import PurchaseList from './components/Retailer/PurchaseList';
import UserProfile from './components/UserProfile';
import { Button, Dialog, DialogActions, DialogContent, makeStyles, Slide } from '@material-ui/core';
import { useCookies } from 'react-cookie';
import SportsEvents from './components/Retailer/SportsEvents';
import CreateSportEvent from './components/Retailer/CreateSportEvent';
import TermsConditions from './components/TermsConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import CancellationRefund from './components/CancellationRefund';
import ShippingDelivery from './components/ShippingDelivery';
import FranchiseEvents from './components/Retailer/FranchiseEvents';
import CreateFranchiseEvents from './components/Retailer/CreateFranchiseEvents';
import Skeleton from './components/Skeleton';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentFailed from './components/PaymentFailed';
import FetchPayments from './components/FetchPayments';
import AllParty from './components/Retailer/party/AllParty';
import CreateParty from './components/Retailer/party/CreateParty';
import ImportParty from './components/Retailer/party/ImportParty';
import AllTeam from './components/Retailer/team/AllTeam';
import CreateTeam from './components/Retailer/team/CreateTeam';
import ImportTeam from './components/Retailer/team/ImportTeam';
import AllProductAndSales from './components/Retailer/productAndSales/AllProductAndSales';
import CreateProductAndSales from './components/Retailer/productAndSales/CreateProductAndSales';
import ImportProductAndSales from './components/Retailer/productAndSales/ImportProductAndSales';
import AllProductAndPurchase from './components/Retailer/productAndPurchase/AllProductAndPurchase';
import CreateProductAndPurchase from './components/Retailer/productAndPurchase/CreateProductAndPurchase';
import ImportProductAndPurchase from './components/Retailer/productAndPurchase/ImportProductAndPurchase';
import PurchaseBillsHistory from './components/Retailer/purchaseBills/PurchaseBillsHistory';
import CreatePurchaseBills from './components/Retailer/purchaseBills/CreatePurchaseBills';
import SalesBillsHistory from './components/Retailer/salesBills/SalesBillsHistory';
import CreateSalesBills from './components/Retailer/salesBills/CreateSalesBills';
import InventoriesHistory from './components/Retailer/inventories/InventoriesHistory';
import UpdateStock from './components/Retailer/inventories/UpdateStock';
import LoginRetailer from './components/Retailer/LoginRetailer';
import UpdateProfile from './components/Retailer/UpdateProfile';
import ChemistOrderHistory from './components/Retailer/supplyOrder/ChemistOrderHistory';
import CreateChemistOrder from './components/Retailer/supplyOrder/CreateChemistOrder';
import WholesalerOrderHistory from './components/Retailer/supplyOrder/WholesalerOrderHistory';
import SupplyOrderHistory from './components/Retailer/supplyOrder/SupplyOrderHistory';
import SupplyFrequentlyOrderHistory from './components/Retailer/supplyOrder/SupplyFrequentlyOrderHistory';
import AuthenticateEmployer from './Router/AuthenticateEmployer';
import RateList from './components/Retailer/supplyOrder/RateList';
import GuestRateList from './components/GuestRateList';
import WholesalerImportProduct from './components/Retailer/supplyOrder/WholesalerImportProduct';
import UsersHistory from './components/Retailer/supplyOrder/UsersHistory';
import CreateSupplyOrder from './components/Retailer/supplyOrder/CreateSupplyOrder';
import GenerateOrderInvoice from './components/Retailer/supplyOrder/GenerateOrderInvoice';
import SupplyOrderBillsHistory from './components/Retailer/supplyOrder/SupplyOrderBillsHistory';
import CreateSupplyOrderWithInvoice from './components/Retailer/supplyOrder/CreateSupplyOrderWithInvoice';
import EditSupplyOrderWithInvoice from './components/Retailer/supplyOrder/EditSupplyOrderWithInvoice';
import AddExtraMedicine from './components/Retailer/supplyOrder/AddExtraMedicine';
import ImportExtraMedicine from './components/Retailer/supplyOrder/ImportExtraMedicine';
import MedicineBasedOnChemist from './components/Retailer/supplyOrder/MedicineBasedOnChemist';
import MedicineReturns from './components/Retailer/supplyOrder/MedicineReturns';
import SupplyMedicine from './components/Retailer/supplyOrder/SupplyMedicine';
import SupplyPurchaseFlow from './components/Retailer/supplyOrder/SupplyPurchaseFlow';
import SupplyPickupFlow from './components/Retailer/supplyOrder/SupplyPickupFlow';
import SupplyDistributionFlow from './components/Retailer/supplyOrder/SupplyDistributionFlow';
import UploadExcelPdfInvoice from './components/Retailer/supplyOrder/UploadExcelPdfInvoice';
import SupplyExcelPdfInvoiceHistory from './components/Retailer/supplyOrder/SupplyExcelPdfInvoiceHistory';
import ChemistExcelPdfInvoiceHistory from './components/Retailer/supplyOrder/ChemistExcelPdfInvoiceHistory';
import SchemeList from './components/Retailer/supplyOrder/SchemeList';
import GenerateOrderInvoiceFromExcel from './components/Retailer/supplyOrder/GenerateOrderInvoiceFromExcel';
import ChemistMedicineReturns from './components/Retailer/supplyOrder/ChemistMedicineReturns';
import HostingRedirectPopup from './components/HostingRedirectPopup';
const HomeScreen = React.lazy(() => import('./components/HomeScreen'));

const useSyles = makeStyles(theme => ({
  dialogWrapper: {
    padding: theme.spacing(2),
    position: 'absolute',
    top: theme.spacing(2)
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function App() {
  const [openPopup, setOpenPopup] = useState(false);
  const [isFooterDisabled, setIsFooterDisabled] = useState(false);
  const classes = useSyles();
  const [cookies, setCookie] = useCookies(['user']);
  const location = useLocation();

  const handleClick = (tag) => {
    if (tag === 'accept') {
      setOpenPopup(false);
      setCookie('userConfig', {
        isCookieAccept: true
      }, { path: '/' });
    } else {
      setOpenPopup(false);
      setCookie('userConfig', {
        isCookieAccept: false
      }, { path: '/' });
    }
  };

  useEffect(() => {
    return () => document.body.style.overflow = 'scroll';
  }, []);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    setIsFooterDisabled(location.pathname.includes('/products'))
  }, [location]);

  return (
    <div className="app">
      <Switch>
        <Route exact path="/activity/dashboard">
          <Dashboard productView="Dashboard">
            <Index />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/create-product">
          <Dashboard productView="Create New Product">
            <CreateProduct />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/import-product">
          <Dashboard productView="Import Product From Excel">
            <ImportProduct />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/all-products">
          <Dashboard productView="Products">
            <AllProducts />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/parties">
          <Dashboard productView="Parties">
            <AllParty />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/create-party">
          <Dashboard productView="Create New Party">
            <CreateParty />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/import-party">
          <Dashboard productView="Import Party From Excel">
            <ImportParty />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/my-team">
          <Dashboard productView="Team">
            <AllTeam />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/add-member">
          <Dashboard productView="Add Member">
            <CreateTeam />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/import-member">
          <Dashboard productView="Import Member From Excel">
            <ImportTeam />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/all-product-and-sales">
          <Dashboard productView="Product And Sales Details">
            <AllProductAndSales />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/create-product-and-sales">
          <Dashboard productView="Create Product And Sales Details">
            <CreateProductAndSales />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/import-product-and-sales">
          <Dashboard productView="Import Product And Sales Details From Excel">
            <ImportProductAndSales />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/all-product-and-purchase">
          <Dashboard productView="Product And Purchase Details">
            <AllProductAndPurchase />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/create-product-and-purchase">
          <Dashboard productView="Create Product And Purchase Details">
            <CreateProductAndPurchase />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/import-product-and-purchase">
          <Dashboard productView="Import Product And Purchase Details From Excel">
            <ImportProductAndPurchase />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/purchase-history">
          <Dashboard productView="Purchase History">
            <PurchaseBillsHistory />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/create-purchase-bills">
          <Dashboard productView="Create Purchase Bills">
            <CreatePurchaseBills />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/sales-history">
          <Dashboard productView="Sales History">
            <SalesBillsHistory />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/create-sales-bills">
          <Dashboard productView="Create Sales Bills">
            <CreateSalesBills />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/inventories">
          <Dashboard productView="Inventories">
            <InventoriesHistory />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/update-stock">
          <Dashboard productView="Update Stock">
            <UpdateStock />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/health-camps">
          <Dashboard productView="Health Camps">
            <HealthCamps />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/create-health-camps">
          <Dashboard productView="Create New Health Camps">
            <CreateHealthCamps />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/pharma-events">
          <Dashboard productView="Pharma Events">
            <PharmaEvents />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/create-pharma-events">
          <Dashboard productView="Create New Pharma Events">
            <CreatePharmaEvents />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/franchise-events">
          <Dashboard productView="Franchise">
            <FranchiseEvents />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/create-franchise-events">
          <Dashboard productView="Create New Franchise">
            <CreateFranchiseEvents />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/sport-events">
          <Dashboard productView="Sport Events">
            <SportsEvents />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/create-sport-event">
          <Dashboard productView="Create New Sport Event">
            <CreateSportEvent />
          </Dashboard>
        </Route>
        <Route exact path="/activity/profile">
          <Dashboard productView="Profile">
            <StoreProfileWrap />
          </Dashboard>
        </Route>
        <Route exact path="/activity/update-profile">
          <Dashboard productView="Profile">
            <UpdateProfile />
          </Dashboard>
        </Route>
        <Route exact path="/retailer/purchase-list/:id">
          <Dashboard productView="Purchase List">
            <PurchaseList />
          </Dashboard>
        </Route>
        {/* Supply Dashboard Start */}
        <Route exact path="/supply/dashboard">
          <Dashboard productView="Dashboard">
            <Index />
          </Dashboard>
        </Route>
        <Route exact path="/supply/update-profile">
          <Dashboard productView="Profile">
            <UpdateProfile />
          </Dashboard>
        </Route>
        <Route exact path="/chemist/order">
          <Dashboard productView="Orders">
            <ChemistOrderHistory />
          </Dashboard>
        </Route>
        <Route exact path="/chemist/create-order">
          <Dashboard productView="Create Order">
            <CreateChemistOrder />
          </Dashboard>
        </Route>
        <Route exact path="/chemist/invoices">
          <Dashboard productView="All Invoices">
            <ChemistExcelPdfInvoiceHistory />
          </Dashboard>
        </Route>
        <Route exact path="/chemist/scheme-list">
          <Dashboard productView="Medicine Scheme">
            <SchemeList />
          </Dashboard>
        </Route>
        <Route exact path="/chemist/goods-return">
          <Dashboard productView="Return/Bounce Medicine">
            <ChemistMedicineReturns />
          </Dashboard>
        </Route>
        <Route exact path="/wholesaller/order">
          <Dashboard productView="Orders">
            <WholesalerOrderHistory />
          </Dashboard>
        </Route>
        <Route exact path="/wholesaller/import">
          <Dashboard productView="Import Product">
            <WholesalerImportProduct />
          </Dashboard>
        </Route>
        <Route exact path="/supply/users">
          <Dashboard productView="Users">
            <UsersHistory />
          </Dashboard>
        </Route>
        <Route exact path="/supply/order">
          <Dashboard productView="Orders">
            <SupplyOrderHistory />
          </Dashboard>
        </Route>
        <Route exact path="/supply/frequently/order">
          <Dashboard productView="Frequently Orders">
            <SupplyFrequentlyOrderHistory />
          </Dashboard>
        </Route>
        <Route exact path="/supply/distribution">
          <Dashboard productView="Distribution">
            <SupplyDistributionFlow />
          </Dashboard>
        </Route>
        <Route exact path="/supply/purchase">
          <Dashboard productView="Purchase">
            <SupplyPurchaseFlow />
          </Dashboard>
        </Route>
        <Route exact path="/supply/pickup">
          <Dashboard productView="Pickup">
            <SupplyPickupFlow />
          </Dashboard>
        </Route>
        <Route exact path="/supply/edit-order-generate-invoice">
          <Dashboard productView="Create Order and Generate Invoice">
            <EditSupplyOrderWithInvoice />
          </Dashboard>
        </Route>
        <Route exact path="/supply/create-order-generate-invoice">
          <Dashboard productView="Create Order and Generate Invoice">
            <CreateSupplyOrderWithInvoice />
          </Dashboard>
        </Route>
        <Route exact path="/supply/create-order">
          <Dashboard productView="Create Order">
            <CreateSupplyOrder />
          </Dashboard>
        </Route>
        <Route exact path="/supply/invoice-history">
          <Dashboard productView="Supply Invoice History">
            <SupplyOrderBillsHistory />
          </Dashboard>
        </Route>
        <Route exact path="/supply/generate-invoice">
          <Dashboard productView="Generate Invoice">
            <GenerateOrderInvoice />
          </Dashboard>
        </Route>
        <Route exact path="/supply/generate-excel-invoice">
          <Dashboard productView="Generate Invoice From Excel">
            <GenerateOrderInvoiceFromExcel />
          </Dashboard>
        </Route>
        <Route exact path="/supply/upload-excel-invoice">
          <Dashboard productView="Upload Excel Invoice">
            <UploadExcelPdfInvoice />
          </Dashboard>
        </Route>
        <Route exact path="/supply/all-excel-invoices">
          <Dashboard productView="All Excel Invoice">
            <SupplyExcelPdfInvoiceHistory />
          </Dashboard>
        </Route>
        <Route exact path="/supply/rate-list">
          <Dashboard productView="Medicine Rate List">
            <RateList />
          </Dashboard>
        </Route>
        <Route exact path="/supply/scheme-list">
          <Dashboard productView="Medicine Scheme">
            <SchemeList />
          </Dashboard>
        </Route>
        <Route exact path="/supply/medicine">
          <Dashboard productView="Supply Medicine">
            <SupplyMedicine />
          </Dashboard>
        </Route>
        <Route exact path="/supply/add-extra-medicine">
          <Dashboard productView="Add Extra Medicine">
            <AddExtraMedicine />
          </Dashboard>
        </Route>
        <Route exact path="/supply/import-extra-medicine">
          <Dashboard productView="Import Extra Medicine From Invoice">
            <ImportExtraMedicine />
          </Dashboard>
        </Route>
        <Route exact path="/supply/filter-medicine">
          <Dashboard productView="Medicine Based On Chemist">
            <MedicineBasedOnChemist />
          </Dashboard>
        </Route>
        <Route exact path="/supply/goods-return">
          <Dashboard productView="Return/Bounce Medicine for Chemist">
            <MedicineReturns />
          </Dashboard>
        </Route>
        {/* Supply Dashboard End */}
        <Route exact path="/activity/Login" component={LoginRetailer} />
        <Route exact path="/activity/Register" component={RegisterRetailer} />
        <Route exact path="/retailer/choose-pricing" component={ChoosePricing} />
        <Route exact path="/register" component={MultiStepRegister} />
        <div className="userRoute">
          <Navbar />
          <Route exact path="/retailer-details/:uid" component={RetailerDetails} />
          <Route exact path="/medical-details/:uid" component={MedicalEventsDetails} />
          <Route exact path="/sport-details/:uid" component={SportEventDetails} />
          <Route exact path="/booking-details/:uid" component={SportBookingDetails} />
          <Route exact path="/products/:isProductTitle?" component={Products} />
          <Route exact path="/pricing" component={Pricing} />
          <Route exact path="/contact" component={Contact} />
          <Route exact path="/about" component={About} />
          <Route exact path="/events" component={Events} />
          <Route exact path="/records/:category?" component={AllRecords} />
          <Route exact path="/terms-conditions" component={TermsConditions} />
          <Route exact path="/privacy-policy" component={PrivacyPolicy} />
          <Route exact path="/cancellation-refund" component={CancellationRefund} />
          <Route exact path="/shipping-delivery" component={ShippingDelivery} />
          <Route exact path="/payment-success/:paymentId" component={PaymentSuccess} />
          <Route exact path="/payment-failed" component={PaymentFailed} />
          <Route exact path="/payments" component={FetchPayments} />
          <Route exact path="/guest/rate-list" component={GuestRateList} />
          <Route exact path="/notAuthorized" component={NotAuthorized} />
          <AuthenticateUser exact path="/user-profile" component={UserProfile} />
          <Suspense fallback={<Skeleton />}>
            <Route exact path="/home" component={HomeScreen} />
            <Route exact path="/" component={HomeScreen} />
          </Suspense>
          {/* <Redirect to="/" /> */}
          {!isFooterDisabled && <Footer />}
        </div>
      </Switch>


      <Dialog open={openPopup} classes={{ paper: classes.dialogWrapper }} maxWidth='sm'
        fullWidth={true} TransitionComponent={Transition}>
        <DialogContent>
          <div className="row mb-3">
            <div className="col-md-12">
              <div className="text-left">
                <h3>This website uses cookies</h3>
              </div>
            </div>
            <div className="col-md-12 mt-3">
              <div style={{ fontSize: '20px' }}>
                Click to agree and allow us to improve and personalize your experience on our website.
                You can change your mind at any time&nbsp;
                <a href="https://kaipsoolretail.web.app/" target="_blank"
                  style={{ fontSize: '22px', fontWeight: 'bold' }}>About cookies</a>
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button size="large" onClick={() => handleClick('decline')}>
            Decline
          </Button>
          <Button autoFocus size="large" onClick={() => handleClick('accept')}>
            Accept
          </Button>
        </DialogActions>
      </Dialog>
      <HostingRedirectPopup />
    </div>
  );
}

export default App;
